import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
var selectThemeNative = {
  color: 'primary',
  height: 60,
  borderWidth: 2,
  fontSize: 18,
  label: {
    size: 12,
    color: colors.octoberGrey,
    selectedColor: 'text'
  },
  // variables for the select screen
  screen: {
    background: 'background',
    text: 'text',
    topBar: {
      height: 80,
      leftMargin: 4,
      buttonWidth: 56,
      searchHeight: 64,
      searchOffset: 4
    },
    leftMargin: 24,
    rightMargin: 24
  },
  divider: {
    fontSize: 18,
    background: colors.lightGrey,
    height: 64
  },
  borderColor: {
    inactive: colors.fogGrey,
    disabled: colors.fogGrey,
    readOnly: colors.snowWhite
  },
  background: {
    disabled: colors.lightGrey
  },
  textColor: {
    disabled: colors.fogGrey
  },
  confirmButton: {
    height: 64
  }
};

var selectDarkThemeNative = _extends({}, selectThemeNative, {
  label: _extends({}, selectThemeNative.label, {
    color: colors.fogGrey
  }),
  divider: _extends({}, selectThemeNative.divider, {
    background: colors.mineShaftGrey
  })
});

var selectThemeWeb = {
  color: 'primary',
  background: 'background',
  error: 'alert',
  textColor: 'text',
  borderStyle: 'full',
  label: {
    color: colors.octoberGrey,
    fontWeight: 400
  },
  inactive: colors.fogGrey,
  disabled: {
    label: colors.fogGrey,
    background: colors.lightGrey
  }
};

var selectDarkThemeWeb = _extends({}, selectThemeWeb, {
  label: _extends({}, selectThemeWeb.label, {
    color: colors.silverGrey
  }),
  inactive: colors.octoberGrey,
  disabled: {
    label: colors.octoberGrey,
    background: colors.mineShaftGrey
  }
});

export { selectDarkThemeNative, selectDarkThemeWeb, selectThemeNative, selectThemeWeb };